<template>
  <div class="flex h-screen">
      <div class="m-auto bg- shadow-lg rounded-lg px-6 py-4 ">
        <h1 class="text-6xl font-mono text-blue-900">
          Fatlum Gjinofci
        </h1>
        <div class="text-center">
          <span class="px-3 text-3xl github-logo">
            <a href="https://github.com/FatlumGjinofci">
              <i class="fab fa-github"></i>
            </a>
          </span>
          <span class="px-3 text-3xl linkedin-logo">
            <a href="https://www.linkedin.com/in/fatlum-gjinofci-5a8162131/">
              <i class="fab fa-linkedin"></i>
            </a>
          </span>
          <span class="px-3 text-3xl twitter-logo">
            <a href="https://twitter.com/Fatlum_Gjinofci">
              <i class="fab fa-twitter"></i>
            </a>
          </span>
          <span class="px-3 text-3xl instagram-logo">
            <a href="https://instagram.com/fatlumgjinofci">
              <i class="fab fa-instagram"></i>
            </a>
          </span>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  components: {
  }
}
</script>

<style scoped>
  .github-logo {
    color: #4078c0;
  }
  .linkedin-logo {
    color: #0e76a8;
  }
  .twitter-logo {
    color: #00acee;
  }
  .instagram-logo {
    color: #8a3ab9;
  }
</style>
